import { FixedWingLine } from '../models/fixed-wing.models';

/** Structural equality for plain data (the mapped DTOs hold only primitives, arrays and objects). */
function deepEqual(a: unknown, b: unknown): boolean {
  if (a === b) {
    return true;
  }
  if (typeof a !== 'object' || typeof b !== 'object' || a === null || b === null) {
    return false;
  }
  if (Array.isArray(a) !== Array.isArray(b)) {
    return false;
  }
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);
  return (
    keysA.length === keysB.length &&
    keysA.every((key) =>
      deepEqual((a as Record<string, unknown>)[key], (b as Record<string, unknown>)[key])
    )
  );
}

/**
 * Applies a backend result to the current lines while keeping the old object for everything that
 * did not actually change. Order is the backend's, but if nothing differs at all the previous array
 * itself is returned, so selectors, change detection and animations see no change and the board
 * stays still when the response only confirms what is already shown.
 */
export function reconcileFixedWingLines(
  current: FixedWingLine[],
  incoming: FixedWingLine[]
): FixedWingLine[] {
  const currentById = new Map(current.map((line) => [line.id, line]));
  const merged = incoming.map((line) => {
    const existing = currentById.get(line.id);
    return existing && deepEqual(existing, line) ? existing : line;
  });
  const unchanged =
    merged.length === current.length && merged.every((line, index) => line === current[index]);
  return unchanged ? current : merged;
}
